import { inject, Pipe, PipeTransform } from '@angular/core';
import { NotificationService } from '@lx/shared/logger';
import { DateFormat, DateFormatService } from '@lx/shared/i18n';
import { DurationUnitsService, getDateFromString } from '@lx/shared/utils';
import { DurationUnit, DurationUnitEnum } from '@lx/shared/data-access/types';

@Pipe({
  standalone: true,
  name: 'lxStudyPeriod',
})
export class StudyPeriodPipe implements PipeTransform {
  private readonly dateFormatService = inject(DateFormatService);
  private readonly notificationService = inject(NotificationService);
  private readonly durationUnitsService = inject(DurationUnitsService);

  transform(startDateStr: string, endDateStr: string, durationInWeeks?: number, durationUnit: DurationUnit = DurationUnitEnum.WEEKS): string {
    if (!startDateStr || !endDateStr) {
      return '';
    }

    try {
      const startDate = getDateFromString(startDateStr);
      const endDate = getDateFromString(endDateStr);

      return this.getFormattedStudyPeriod(startDate, endDate, durationInWeeks, durationUnit);
    } catch (error) {
      this.notificationService.warn('Invalid date(s)');
      return '';
    }
  }

  private getFormattedStudyPeriod(startDate: Date, endDate: Date, duration?: number | undefined, durationUnit: DurationUnit = DurationUnitEnum.WEEKS): string {
    let formattedDate: string;
    if (startDate.getFullYear() !== endDate.getFullYear()) {
      formattedDate = `${this.dateFormatService.formatDate(startDate, DateFormat.SHORT_MONTH_NAME)} - ${this.dateFormatService.formatDate(
        endDate,
        DateFormat.SHORT_MONTH_NAME,
      )}`;
    } else if (startDate.getMonth() === endDate.getMonth()) {
      formattedDate = `${startDate.getDate()} - ${this.dateFormatService.formatDate(endDate, DateFormat.SHORT_MONTH_NAME)}`;
    } else {
      formattedDate = `${this.dateFormatService.formatDate(startDate, 'd MMM')} - ${this.dateFormatService.formatDate(endDate, DateFormat.SHORT_MONTH_NAME)}`;
    }

    if (duration === undefined || duration === null) {
      return formattedDate;
    }

    return `${this.durationUnitsService.getDurationText(duration, durationUnit)} (${formattedDate})`;
  }
}
